/**
 * Whether the Student Reports nav item is shown.
 *
 * A student report is a timeline of one child ACROSS sessions, so it needs a
 * child who is the same person in each of them. A school with no SSO gives its
 * students no identity that survives a session, so there is nothing to put on
 * that timeline.
 *
 * A null school is "not answered yet", not "no SSO": `account/educator` is
 * still in flight, and showing the item now would only take it away.
 *
 * @param {{auth_method?: string|null}|null} activeSchool The educator's school.
 * @returns {boolean}
 */
export const showsStudentReports = (activeSchool) => {
  if (!activeSchool) return false;
  const method = activeSchool.auth_method ?? null;
  return method !== null && method !== "anonymous";
};
